import * as Safe from "safe-portals";

export interface ActionTypeDefinition<T_admin, T_public> {
  /** name of the plugin implementing this action type */
  plugin: string;
  /** unique action type identifier */
  action_type: string;
  /* custom properties when editing this action type in a journey */
  custom_config_type: Safe.Obj<T_admin>;
  /* default custom_config values when a new action node of this type is created */
  custom_config_defaults: T_admin;
  /* custom data passed to the action component when the action is started (public-facing) */
  custom_data_type: Safe.Obj<T_public>;
  check_valid: (config: T_admin) => { valid: boolean; errors: Record<string, string> };
  supports_a_b_tests: boolean;
}

export function makeActionTypeDefinition<T_admin, T_public>(def: ActionTypeDefinition<T_admin, T_public>) {
  return def;
}
